const awsmobile = {
  aws_project_region: process.env.REACT_APP_COGNITO_REGION,
  aws_cognito_region: process.env.REACT_APP_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_COGNITO_CLIENT_APP_ID,
  oauth: {},
};

export default awsmobile;
